module.exports = __webpack_public_path__ + "static/exterior-1-6f8611257ceb1d71982c0826831b6298.jpg";